import { Button } from '@/components/ui/button';

import MailIcon from '@/assets/images/icons/mail.svg';
import PhoneIcon from '@/assets/images/icons/phone.svg';
import { useFormContext } from 'react-hook-form';

const LoginMethodToggle = () => {
	const form = useFormContext();

	const grantType = form?.watch('grantType');

	const handleToggle = () => {
		form?.setValue('grantType', grantType === 'phone' ? 'email' : 'phone');
	};

	return (
		<div>
			{grantType === 'phone' ? (
				<Button
					variant="outline"
					size="full"
					type="button"
					className="relative px-4 py-3 text-base"
					onClick={handleToggle}>
					<img className="absolute left-4" src={MailIcon} alt="mail icon" />{' '}
					Continue with Email
				</Button>
			) : (
				<Button
					variant="outline"
					size="full"
					type="button"
					className="relative px-4 py-3 text-base"
					onClick={handleToggle}>
					<img className="absolute left-4" src={PhoneIcon} alt="phone icon" />{' '}
					Continue with Phone number
				</Button>
			)}
		</div>
	);
};

export default LoginMethodToggle;
